// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               unknown
// source: photon/imessage/v1/chat_types.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../../../google/protobuf/timestamp.js";
import {
  ChatServiceType,
  chatServiceTypeFromJSON,
  chatServiceTypeToJSON,
  SingleServiceAddressInfo,
} from "./address_types.js";
import { Message } from "./message_types.js";

export const protobufPackage = "photon.imessage.v1";

/**
 * Canonical projection of a row in chat.db's `chat` table joined with its
 * participants and (optionally) its most recent message.
 */
export interface Chat {
  /**
   * System-assigned chat GUID. Stable across renames and participant
   * changes; the canonical key for every chat-scoped RPC.
   */
  guid: string;
  /**
   * Apple's `chat_identifier` column. For 1:1 chats this is the peer's
   * E.164 phone or email; for group chats it is the synthetic group ID.
   */
  chatIdentifier?:
    | string
    | undefined;
  /** Stable iMessage group ID. Set on group chats only. */
  groupId?: string | undefined;
  displayName?: string | undefined;
  isGroup: boolean;
  service: ChatServiceType;
  isArchived: boolean;
  /**
   * `true` when Apple has routed the chat to "Unknown Senders" / the
   * junk filter.
   */
  isFiltered: boolean;
  /**
   * Absent when the underlying count is unavailable (e.g. chat row not
   * yet hydrated). `0` is a real "all read" value, not "unknown".
   */
  unreadCount?: number | undefined;
  participants: SingleServiceAddressInfo[];
  lastMessage?: Message | undefined;
}

/**
 * Chat background bytes have been replaced. The new bytes are not
 * embedded; fetch via `ChatService.HasBackground` / out-of-band asset
 * retrieval. Mirrors the `GroupIconChanged` pattern.
 */
export interface ChatBackgroundChanged {
}

/** Chat background bytes have been removed. */
export interface ChatBackgroundRemoved {
}

/** Chat unread count transitioned to zero (locally or via continuity). */
export interface ChatMarkedRead {
}

/** Chat moved into the archived view. */
export interface ChatArchived {
}

/** Chat moved out of the archived view. */
export interface ChatUnarchived {
}

/**
 * A discrete state transition observed on a chat row itself (not on its
 * messages). Membership and group-name transitions remain on
 * `GroupChangeEvent`.
 */
export interface ChatChangeEvent {
  chatGuid: string;
  occurredAt: Date | undefined;
  actor?: SingleServiceAddressInfo | undefined;
  isFromMe: boolean;
  backgroundChanged?: ChatBackgroundChanged | undefined;
  backgroundRemoved?: ChatBackgroundRemoved | undefined;
  markedRead?: ChatMarkedRead | undefined;
  archived?: ChatArchived | undefined;
  unarchived?: ChatUnarchived | undefined;
}

function createBaseChat(): Chat {
  return {
    guid: "",
    chatIdentifier: undefined,
    groupId: undefined,
    displayName: undefined,
    isGroup: false,
    service: 0,
    isArchived: false,
    isFiltered: false,
    unreadCount: undefined,
    participants: [],
    lastMessage: undefined,
  };
}

export const Chat: MessageFns<Chat> = {
  encode(message: Chat, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.guid !== "") {
      writer.uint32(10).string(message.guid);
    }
    if (message.chatIdentifier !== undefined) {
      writer.uint32(18).string(message.chatIdentifier);
    }
    if (message.groupId !== undefined) {
      writer.uint32(26).string(message.groupId);
    }
    if (message.displayName !== undefined) {
      writer.uint32(34).string(message.displayName);
    }
    if (message.isGroup !== false) {
      writer.uint32(40).bool(message.isGroup);
    }
    if (message.service !== 0) {
      writer.uint32(48).int32(message.service);
    }
    if (message.isArchived !== false) {
      writer.uint32(56).bool(message.isArchived);
    }
    if (message.isFiltered !== false) {
      writer.uint32(64).bool(message.isFiltered);
    }
    if (message.unreadCount !== undefined) {
      writer.uint32(72).int32(message.unreadCount);
    }
    for (const v of message.participants) {
      SingleServiceAddressInfo.encode(v!, writer.uint32(82).fork()).join();
    }
    if (message.lastMessage !== undefined) {
      Message.encode(message.lastMessage, writer.uint32(90).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Chat {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChat();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.guid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.chatIdentifier = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.groupId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.displayName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.isGroup = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.service = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.isArchived = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.isFiltered = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.unreadCount = reader.int32();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.participants.push(SingleServiceAddressInfo.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.lastMessage = Message.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Chat {
    return {
      guid: isSet(object.guid) ? globalThis.String(object.guid) : "",
      chatIdentifier: isSet(object.chatIdentifier)
        ? globalThis.String(object.chatIdentifier)
        : isSet(object.chat_identifier)
        ? globalThis.String(object.chat_identifier)
        : undefined,
      groupId: isSet(object.groupId)
        ? globalThis.String(object.groupId)
        : isSet(object.group_id)
        ? globalThis.String(object.group_id)
        : undefined,
      displayName: isSet(object.displayName)
        ? globalThis.String(object.displayName)
        : isSet(object.display_name)
        ? globalThis.String(object.display_name)
        : undefined,
      isGroup: isSet(object.isGroup)
        ? globalThis.Boolean(object.isGroup)
        : isSet(object.is_group)
        ? globalThis.Boolean(object.is_group)
        : false,
      service: isSet(object.service) ? chatServiceTypeFromJSON(object.service) : 0,
      isArchived: isSet(object.isArchived)
        ? globalThis.Boolean(object.isArchived)
        : isSet(object.is_archived)
        ? globalThis.Boolean(object.is_archived)
        : false,
      isFiltered: isSet(object.isFiltered)
        ? globalThis.Boolean(object.isFiltered)
        : isSet(object.is_filtered)
        ? globalThis.Boolean(object.is_filtered)
        : false,
      unreadCount: isSet(object.unreadCount)
        ? globalThis.Number(object.unreadCount)
        : isSet(object.unread_count)
        ? globalThis.Number(object.unread_count)
        : undefined,
      participants: globalThis.Array.isArray(object?.participants)
        ? object.participants.map((e: any) => SingleServiceAddressInfo.fromJSON(e))
        : [],
      lastMessage: isSet(object.lastMessage)
        ? Message.fromJSON(object.lastMessage)
        : isSet(object.last_message)
        ? Message.fromJSON(object.last_message)
        : undefined,
    };
  },

  toJSON(message: Chat): unknown {
    const obj: any = {};
    if (message.guid !== "") {
      obj.guid = message.guid;
    }
    if (message.chatIdentifier !== undefined) {
      obj.chatIdentifier = message.chatIdentifier;
    }
    if (message.groupId !== undefined) {
      obj.groupId = message.groupId;
    }
    if (message.displayName !== undefined) {
      obj.displayName = message.displayName;
    }
    if (message.isGroup !== false) {
      obj.isGroup = message.isGroup;
    }
    if (message.service !== 0) {
      obj.service = chatServiceTypeToJSON(message.service);
    }
    if (message.isArchived !== false) {
      obj.isArchived = message.isArchived;
    }
    if (message.isFiltered !== false) {
      obj.isFiltered = message.isFiltered;
    }
    if (message.unreadCount !== undefined) {
      obj.unreadCount = Math.round(message.unreadCount);
    }
    if (message.participants?.length) {
      obj.participants = message.participants.map((e) => SingleServiceAddressInfo.toJSON(e));
    }
    if (message.lastMessage !== undefined) {
      obj.lastMessage = Message.toJSON(message.lastMessage);
    }
    return obj;
  },

  create(base?: DeepPartial<Chat>): Chat {
    return Chat.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Chat>): Chat {
    const message = createBaseChat();
    message.guid = object.guid ?? "";
    message.chatIdentifier = object.chatIdentifier ?? undefined;
    message.groupId = object.groupId ?? undefined;
    message.displayName = object.displayName ?? undefined;
    message.isGroup = object.isGroup ?? false;
    message.service = object.service ?? 0;
    message.isArchived = object.isArchived ?? false;
    message.isFiltered = object.isFiltered ?? false;
    message.unreadCount = object.unreadCount ?? undefined;
    message.participants = object.participants?.map((e) => SingleServiceAddressInfo.fromPartial(e)) || [];
    message.lastMessage = (object.lastMessage !== undefined && object.lastMessage !== null)
      ? Message.fromPartial(object.lastMessage)
      : undefined;
    return message;
  },
};

function createBaseChatBackgroundChanged(): ChatBackgroundChanged {
  return {};
}

export const ChatBackgroundChanged: MessageFns<ChatBackgroundChanged> = {
  encode(_: ChatBackgroundChanged, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatBackgroundChanged {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChatBackgroundChanged();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ChatBackgroundChanged {
    return {};
  },

  toJSON(_: ChatBackgroundChanged): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<ChatBackgroundChanged>): ChatBackgroundChanged {
    return ChatBackgroundChanged.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<ChatBackgroundChanged>): ChatBackgroundChanged {
    const message = createBaseChatBackgroundChanged();
    return message;
  },
};

function createBaseChatBackgroundRemoved(): ChatBackgroundRemoved {
  return {};
}

export const ChatBackgroundRemoved: MessageFns<ChatBackgroundRemoved> = {
  encode(_: ChatBackgroundRemoved, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatBackgroundRemoved {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChatBackgroundRemoved();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ChatBackgroundRemoved {
    return {};
  },

  toJSON(_: ChatBackgroundRemoved): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<ChatBackgroundRemoved>): ChatBackgroundRemoved {
    return ChatBackgroundRemoved.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<ChatBackgroundRemoved>): ChatBackgroundRemoved {
    const message = createBaseChatBackgroundRemoved();
    return message;
  },
};

function createBaseChatMarkedRead(): ChatMarkedRead {
  return {};
}

export const ChatMarkedRead: MessageFns<ChatMarkedRead> = {
  encode(_: ChatMarkedRead, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatMarkedRead {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChatMarkedRead();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ChatMarkedRead {
    return {};
  },

  toJSON(_: ChatMarkedRead): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<ChatMarkedRead>): ChatMarkedRead {
    return ChatMarkedRead.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<ChatMarkedRead>): ChatMarkedRead {
    const message = createBaseChatMarkedRead();
    return message;
  },
};

function createBaseChatArchived(): ChatArchived {
  return {};
}

export const ChatArchived: MessageFns<ChatArchived> = {
  encode(_: ChatArchived, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatArchived {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChatArchived();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ChatArchived {
    return {};
  },

  toJSON(_: ChatArchived): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<ChatArchived>): ChatArchived {
    return ChatArchived.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<ChatArchived>): ChatArchived {
    const message = createBaseChatArchived();
    return message;
  },
};

function createBaseChatUnarchived(): ChatUnarchived {
  return {};
}

export const ChatUnarchived: MessageFns<ChatUnarchived> = {
  encode(_: ChatUnarchived, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatUnarchived {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChatUnarchived();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ChatUnarchived {
    return {};
  },

  toJSON(_: ChatUnarchived): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<ChatUnarchived>): ChatUnarchived {
    return ChatUnarchived.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<ChatUnarchived>): ChatUnarchived {
    const message = createBaseChatUnarchived();
    return message;
  },
};

function createBaseChatChangeEvent(): ChatChangeEvent {
  return {
    chatGuid: "",
    occurredAt: undefined,
    actor: undefined,
    isFromMe: false,
    backgroundChanged: undefined,
    backgroundRemoved: undefined,
    markedRead: undefined,
    archived: undefined,
    unarchived: undefined,
  };
}

export const ChatChangeEvent: MessageFns<ChatChangeEvent> = {
  encode(message: ChatChangeEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatGuid !== "") {
      writer.uint32(10).string(message.chatGuid);
    }
    if (message.occurredAt !== undefined) {
      Timestamp.encode(toTimestamp(message.occurredAt), writer.uint32(18).fork()).join();
    }
    if (message.actor !== undefined) {
      SingleServiceAddressInfo.encode(message.actor, writer.uint32(26).fork()).join();
    }
    if (message.isFromMe !== false) {
      writer.uint32(32).bool(message.isFromMe);
    }
    if (message.backgroundChanged !== undefined) {
      ChatBackgroundChanged.encode(message.backgroundChanged, writer.uint32(82).fork()).join();
    }
    if (message.backgroundRemoved !== undefined) {
      ChatBackgroundRemoved.encode(message.backgroundRemoved, writer.uint32(90).fork()).join();
    }
    if (message.markedRead !== undefined) {
      ChatMarkedRead.encode(message.markedRead, writer.uint32(98).fork()).join();
    }
    if (message.archived !== undefined) {
      ChatArchived.encode(message.archived, writer.uint32(106).fork()).join();
    }
    if (message.unarchived !== undefined) {
      ChatUnarchived.encode(message.unarchived, writer.uint32(114).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatChangeEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChatChangeEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chatGuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.occurredAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.actor = SingleServiceAddressInfo.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.isFromMe = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.backgroundChanged = ChatBackgroundChanged.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.backgroundRemoved = ChatBackgroundRemoved.decode(reader, reader.uint32());
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.markedRead = ChatMarkedRead.decode(reader, reader.uint32());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.archived = ChatArchived.decode(reader, reader.uint32());
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.unarchived = ChatUnarchived.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChatChangeEvent {
    return {
      chatGuid: isSet(object.chatGuid)
        ? globalThis.String(object.chatGuid)
        : isSet(object.chat_guid)
        ? globalThis.String(object.chat_guid)
        : "",
      occurredAt: isSet(object.occurredAt)
        ? fromJsonTimestamp(object.occurredAt)
        : isSet(object.occurred_at)
        ? fromJsonTimestamp(object.occurred_at)
        : undefined,
      actor: isSet(object.actor) ? SingleServiceAddressInfo.fromJSON(object.actor) : undefined,
      isFromMe: isSet(object.isFromMe)
        ? globalThis.Boolean(object.isFromMe)
        : isSet(object.is_from_me)
        ? globalThis.Boolean(object.is_from_me)
        : false,
      backgroundChanged: isSet(object.backgroundChanged)
        ? ChatBackgroundChanged.fromJSON(object.backgroundChanged)
        : isSet(object.background_changed)
        ? ChatBackgroundChanged.fromJSON(object.background_changed)
        : undefined,
      backgroundRemoved: isSet(object.backgroundRemoved)
        ? ChatBackgroundRemoved.fromJSON(object.backgroundRemoved)
        : isSet(object.background_removed)
        ? ChatBackgroundRemoved.fromJSON(object.background_removed)
        : undefined,
      markedRead: isSet(object.markedRead)
        ? ChatMarkedRead.fromJSON(object.markedRead)
        : isSet(object.marked_read)
        ? ChatMarkedRead.fromJSON(object.marked_read)
        : undefined,
      archived: isSet(object.archived) ? ChatArchived.fromJSON(object.archived) : undefined,
      unarchived: isSet(object.unarchived) ? ChatUnarchived.fromJSON(object.unarchived) : undefined,
    };
  },

  toJSON(message: ChatChangeEvent): unknown {
    const obj: any = {};
    if (message.chatGuid !== "") {
      obj.chatGuid = message.chatGuid;
    }
    if (message.occurredAt !== undefined) {
      obj.occurredAt = message.occurredAt.toISOString();
    }
    if (message.actor !== undefined) {
      obj.actor = SingleServiceAddressInfo.toJSON(message.actor);
    }
    if (message.isFromMe !== false) {
      obj.isFromMe = message.isFromMe;
    }
    if (message.backgroundChanged !== undefined) {
      obj.backgroundChanged = ChatBackgroundChanged.toJSON(message.backgroundChanged);
    }
    if (message.backgroundRemoved !== undefined) {
      obj.backgroundRemoved = ChatBackgroundRemoved.toJSON(message.backgroundRemoved);
    }
    if (message.markedRead !== undefined) {
      obj.markedRead = ChatMarkedRead.toJSON(message.markedRead);
    }
    if (message.archived !== undefined) {
      obj.archived = ChatArchived.toJSON(message.archived);
    }
    if (message.unarchived !== undefined) {
      obj.unarchived = ChatUnarchived.toJSON(message.unarchived);
    }
    return obj;
  },

  create(base?: DeepPartial<ChatChangeEvent>): ChatChangeEvent {
    return ChatChangeEvent.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ChatChangeEvent>): ChatChangeEvent {
    const message = createBaseChatChangeEvent();
    message.chatGuid = object.chatGuid ?? "";
    message.occurredAt = object.occurredAt ?? undefined;
    message.actor = (object.actor !== undefined && object.actor !== null)
      ? SingleServiceAddressInfo.fromPartial(object.actor)
      : undefined;
    message.isFromMe = object.isFromMe ?? false;
    message.backgroundChanged = (object.backgroundChanged !== undefined && object.backgroundChanged !== null)
      ? ChatBackgroundChanged.fromPartial(object.backgroundChanged)
      : undefined;
    message.backgroundRemoved = (object.backgroundRemoved !== undefined && object.backgroundRemoved !== null)
      ? ChatBackgroundRemoved.fromPartial(object.backgroundRemoved)
      : undefined;
    message.markedRead = (object.markedRead !== undefined && object.markedRead !== null)
      ? ChatMarkedRead.fromPartial(object.markedRead)
      : undefined;
    message.archived = (object.archived !== undefined && object.archived !== null)
      ? ChatArchived.fromPartial(object.archived)
      : undefined;
    message.unarchived = (object.unarchived !== undefined && object.unarchived !== null)
      ? ChatUnarchived.fromPartial(object.unarchived)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
